import { useCallback, useEffect, useState } from 'react'
import moment from "moment";
import "moment/locale/id";
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { FiChevronLeft, FiPlus } from 'react-icons/fi';
import { FaDownload } from "react-icons/fa6";
import { BiSolidUserRectangle } from "react-icons/bi";
import ItemList from '@components/loadingSchedule/ItemList';
import { InventoryItemLoading, NotificationType } from 'react-app-env';
import axios, { AxiosResponse } from 'axios';
import { API_URL } from '@redux/api';
import Loading from '@components/common/Loading';
import Modal from '@components/common/Modal';
import AddNewInventories from '@components/loadingSchedule/AddNewInventories';
import Notification from '@components/common/Notification';

const LoadingInDetails = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const [isLoadingFetch, setIsLoadingFetch] = useState<boolean>(false);
  const [notificationFetch, setNotificationFetch] = useState<NotificationType | null>(null);
  const [isLoadingDownload, setIsLoadingDownload] = useState<boolean>(false);
  const [notificationDownload, setNotificationDownload] = useState<NotificationType | null>(null);
  
  const [isOpenAddInventoriesModal, setIsOpenAddInventoriesModal] = useState<boolean>(false);

  const [sortedInventories, setSortedInventories] = useState<InventoryItemLoading[] | []>([]);

  const fetchLoadingInventories = useCallback(async() => {
    setIsLoadingFetch(true);
    setNotificationFetch(null);

    const response: AxiosResponse = await axios.get(`${API_URL}/loading/${id}/inventories`);
    const { status, data } = response;
    
    if(status === 200) {
      const { inventories } = data.data;
      console.log(inventories);
      const sortedData = inventories.sort((a: InventoryItemLoading, b: InventoryItemLoading) => {
        return a.item.name.localeCompare(b.item.name);
      });

      setSortedInventories(sortedData);
      setIsLoadingFetch(false);
    } else {
      setNotificationFetch({
        isError: true,
        title: "Error",
        text: data.message,
      });
      setIsLoadingFetch(false);
    };
  }, [id]);

  useEffect(() => {
    if (state === null) navigate("/jadwal-loading/in");
    return () => { };
  }, [state, navigate]);

  useEffect(() => {
    if(id) fetchLoadingInventories();
    return () => {}
  }, [id, fetchLoadingInventories]);

  if (state === null) return null;

  const {
    eventDate,
    eventLocation,
    pic
  } = state;

  const onClickDownload = async() => {
    setIsLoadingDownload(true);
    setNotificationDownload(null);

    const fnEventDate = moment(eventDate, "DD/MM/YYYY").format("DD-MM-YYYY");
    const fnEventLocation = eventLocation.split(" ").join("-");
    const filename = `${fnEventDate}_${fnEventLocation}.pdf`;

    const payload = {
      loadingId: id,
      filename
    };

    const response = await axios.post(`${API_URL}/loading/generate-pdf`, payload);
    const { status, message, data } = response.data;

    if(status === 200) {
      const { fileUrl } = data;
      window.open(fileUrl, '_blank');
      setIsLoadingDownload(false);
    } else {
      setIsLoadingDownload(false);
      setNotificationDownload({
        isError: true,
        title: "Download Gagal",
        text: message
      });
    };
  };

  return (
    <div>
      <div className="bg-white rounded-xl p-4">
        <div className='flex items-center'>
          <button onClick={() => navigate("/jadwal-loading/in")} className='pr-4'>
            <FiChevronLeft size={25} />
          </button>
          <h1 className="text-center text-xl w-full md:text-2xl lg:text-4xl font-semibold">Daftar Barang</h1>
        </div>
      </div>

      <div className="bg-white rounded-xl p-4 mt-5">
        <div className='flex items-center justify-center gap-3'>
          <div className="gap-2">
            <strong className="text-lg">{moment(eventDate, "DD/MM/YYYY").format("DD MMM YYYY")}</strong>
            <span className='mx-2'>-</span>
            <strong className="text-lg">{eventLocation}</strong>
          </div>
        </div>
        <hr className="border-gray-300 my-4" />
        <div className="flex items-center justify-center gap-2">
          <BiSolidUserRectangle size={24} />
          <strong>{pic.name}</strong>
          <span>-</span>
          <strong>{pic.phone}</strong>
        </div>
      </div>

      <div className='mt-5'>
        <Notification notification={notificationFetch} />
      </div>

      <div className='mt-5 rounded-xl py-2 px-0'>
        { isLoadingFetch ? 
          <Loading 
            loading={isLoadingFetch}
            size={20}
            type='beat-loader'
            parentClass='mt-8 mb-10'
          />
          : <ItemList inventories={sortedInventories}/>
        }
      </div>

      <div>
        <Notification notification={notificationDownload} className='mb-7 mt-0'/>
      </div>
      
      {isLoadingDownload ? 
        <div className='mt-2'>
          <Loading 
            loading={isLoadingDownload}
            size={20}
            type='beat-loader'
            parentClass='mt-8 mb-10'
          />
        </div>
        : <div className='mt-2 grid grid-cols-2 gap-4 mb-10'>
          <button 
            className='w-full font-semibold bg-orange-500 text-white py-3 lg:py-4 rounded-xl flex items-center justify-center gap-2'
            onClick={() => setIsOpenAddInventoriesModal(true)}
          >
            <FiPlus />
            Tambah barang
          </button>
          <button 
            className='w-full font-semibold bg-sky-500 text-white rounded-xl py-3 lg:py-4 flex items-center justify-center gap-2'
            onClick={onClickDownload}
          >
            <FaDownload />
            Download PDF
          </button>
        </div>
      }

      <Modal
        showCloseButton
        title="Form Tambah Barang"
        isOpen={isOpenAddInventoriesModal}
        onClose={() => setIsOpenAddInventoriesModal(false)}
      >
        <div className="border-t">
          <AddNewInventories 
            loadingId={id}
            recentInventories={sortedInventories}
            onCloseModal={() => {
              setIsOpenAddInventoriesModal(false);
              fetchLoadingInventories();
            }} 
          />
        </div>
      </Modal>
    </div>
  )
}

export default LoadingInDetails